import $ from 'jquery';

export default class StaticCollection {
  constructor(section) {
    this.$el = $(section.el);
    this.$selector = $('.collection-tag-selector select', this.$el);
    this.$selector.on('change', () => this.browseByTag());
  }

  _browseByTag(event) {
    const select = $(event.target);
    const fallback = select.parents('.select-wrapper').find('select').data('fallback-url');
    const newTag = select.parents('.select-wrapper').find(':selected').attr('name');

    if (newTag === 'reset') {
      window.location.href = fallback;
    } else {
      window.location.href = `${fallback}/${newTag}`;
    }
  }

  onSectionUnload() {
    this.$selector.off('change');
  }
}
